import type { InputTableColumn } from '@/components/custom/erp/input-table-v2';
import { CellFieldV2 } from '@/components/custom/erp';

export const getDetailTableColumns = (
  onCellValueChange: (rowUuid: string, field: string, newValue: MuaHangRecord) => void
): InputTableColumn[] => [
  {
    field: 'ma_vt',
    headerName: 'Mã sản phẩm',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_vt' type='text' value={params.row.ma_vt || ''} disabled />
  },
  {
    field: 'ten_vt',
    headerName: 'Tên sản phẩm',
    width: 200,
    renderCell: params => <CellFieldV2 name='ten_vt' type='text' value={params.row.ten_vt || ''} disabled />
  },
  {
    field: 'dvt',
    headerName: 'Đơn vị tính',
    width: 100,
    renderCell: params => <CellFieldV2 name='dvt' type='text' value={params.row.dvt} disabled />
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_kho' type='text' value={params.row.ma_kho} disabled />
  },
  {
    field: 'ma_vi_tri',
    headerName: 'Mã vị trí',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_vi_tri' type='text' value={params.row.ma_vi_tri} disabled />
  },
  {
    field: 'so_luong',
    headerName: 'Số lượng',
    width: 100,
    renderCell: params => <CellFieldV2 name='so_luong' type='number' value={params.row.so_luong} disabled />
  },
  {
    field: 'tien0',
    headerName: 'Tiền hàng',
    width: 120,
    renderCell: params => <CellFieldV2 name='tien0' type='number' value={params.row.tien0} disabled />
  },
  {
    field: 'tien3',
    headerName: 'Tiền tính thuế nk',
    width: 120,
    renderCell: params => <CellFieldV2 name='tien3' type='number' value={params.row.tien3} disabled />
  },
  {
    field: 'cp_nt',
    headerName: 'Chi phí VND',
    width: 120,
    renderCell: params => <CellFieldV2 name='cp_nt' type='number' value={params.row.cp_nt} disabled />
  },
  {
    field: 'tk_vt',
    headerName: 'TK nợ',
    width: 120,
    renderCell: params => <CellFieldV2 name='tk_vt' type='text' value={params.row.tk_vt_data?.code} disabled />
  },
  {
    field: 'thue_nt',
    headerName: 'Thuế GTGT VND',
    width: 120,
    renderCell: params => <CellFieldV2 name='thue_nt' type='number' value={params.row.thue_nt} disabled />
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_bp' type='text' value={params.row.ma_bp_data?.ma_bp} disabled />
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_vv' type='text' value={params.row.ma_vv_data?.ma_vu_viec} disabled />
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_hd' type='text' value={params.row.ma_hd_data?.ma_hd} disabled />
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_dtt' type='text' value={params.row.ma_dtt_data?.ma_dtt} disabled />
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_ku' type='text' value={params.row.ma_ku_data?.ma_ku} disabled />
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_phi' type='text' value={params.row.ma_phi_data?.ma_phi} disabled />
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_sp' type='text' value={params.row.ma_sp_data?.ma_vt} disabled />
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_lsx' type='text' value={params.row.ma_lsx_data?.ma_lsx} disabled />
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 150,
    renderCell: params => <CellFieldV2 name='ma_cp0' type='text' value={params.row.ma_cp0_data?.ma_cp} disabled />
  },
  {
    field: 'so_ct_hd4',
    headerName: 'Số hóa đơn mua trong nước',
    width: 150,
    renderCell: params => <CellFieldV2 name='so_ct_hd4' type='text' value={params.row.so_ct_hd4} disabled />
  },
  {
    field: 'so_ct_hd5',
    headerName: 'Số hóa đơn mua nhập khẩu',
    width: 150,
    renderCell: params => <CellFieldV2 name='so_ct_hd5' type='text' value={params.row.so_ct_hd5 || ''} disabled />
  },
  {
    field: 'so_ct_hd7',
    headerName: 'Số hóa đơn mua xuất thẳng',
    width: 150,
    renderCell: params => <CellFieldV2 name='so_ct_hd5' type='text' value={params.row.so_ct_hd5 || ''} disabled />
  },
  {
    field: 'line_hd',
    headerName: 'Dòng HĐ',
    width: 150,
    renderCell: params => <CellFieldV2 name='line_hd' type='text' value={params.row.line_hd || ''} disabled />
  }
];
